
import { StyledAppTitle, StyledAppTitleLink } from './style';

const AppTitle = () => {
  return (
    <StyledAppTitle>
      <StyledAppTitleLink to='/'>Eeccy</StyledAppTitleLink>
    </StyledAppTitle>
  );
};

export default AppTitle;
